<div class="container">
  <loading-indicator *ngIf="!printOrderModel"></loading-indicator>
  <form class="form-striped" *ngIf="printOrderModel">

    <form-field [config]="formConfig!.type"></form-field>
    <form-field [config]="formConfig!.orderingHospital"></form-field>
    <form-field [config]="formConfig!.operatorHospital"></form-field>
    <form-field [config]="formConfig!.initiatedTime"></form-field>
    <form-field [config]="formConfig!.name"></form-field>
    <form-field [config]="formConfig!.ssn"></form-field>
    <form-field [config]="formConfig!.code"></form-field>
    <form-field [config]="formConfig!.uniqueId"></form-field>

    <div class="row">
      <action-button
        buttonLabel="printOrderFormButtonLabel"
        actionInProgressLabel="printOrderFormButtonInProgressLabel"
        (buttonClick)="onPrintButtonClick(false)"
        [testId]="'submit-button'">
      </action-button>

      <div *ngIf="feature395Released">
        <button
          data-testid="download-order-form-button"
          class="btn btn-primary ms-2"
          (click)="onPrintButtonClick(true)"
        >{{ "downloadOrderFormButtonLabel" | localize }}</button>
      </div>

      <span data-testid="submit-error-message" *ngIf="!!errorMessage" class="alert alert-danger ms-2">
        {{ errorMessage | localize }}
      </span>
    </div>

  </form>
</div>
